var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 23,
    viewBox: "0 0 28 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5683 2.96549C26.5593 3.41258 25.4754 3.71466 24.336 3.8512C25.5117 3.1477 26.3913 2.04047 26.8106 0.736117C25.706 1.39223 24.4971 1.85406 23.2364 2.10153C22.3886 1.19633 21.2657 0.596345 20.0419 0.394732C18.8182 0.193119 17.5622 0.401157 16.4688 0.986548C15.3754 1.57194 14.5059 2.50193 13.9952 3.63213C13.4846 4.76234 13.3613 6.02952 13.6446 7.23695C11.4064 7.12457 9.21684 6.54282 7.21801 5.52946C5.21919 4.5161 3.45577 3.09377 2.04221 1.35478C1.55888 2.18853 1.28096 3.1552 1.28096 4.1847C1.28042 5.11149 1.50865 6.02408 1.9454 6.8415C2.38214 7.65893 3.01391 8.35591 3.78463 8.87062C2.89079 8.84218 2.01668 8.60066 1.23504 8.16616V8.23866C1.23495 9.53851 1.68458 10.7984 2.50764 11.8044C3.3307 12.8105 4.47648 13.5009 5.75059 13.7583C4.92141 13.9827 4.05208 14.0158 3.20825 13.855C3.56773 14.9734 4.26796 15.9515 5.2109 16.6522C6.15385 17.3529 7.29232 17.7412 8.46692 17.7627C6.47297 19.328 4.01045 20.1771 1.4755 20.1734C1.02646 20.1735 0.577803 20.1473 0.131836 20.0948C2.70495 21.7492 5.70025 22.6273 8.75934 22.6239C19.1147 22.6239 24.7758 14.0471 24.7758 6.60862C24.7758 6.36695 24.7698 6.12287 24.7589 5.8812C25.86 5.08488 26.8105 4.09878 27.5658 2.96912L27.5683 2.96549Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.24375631ed85e17bc37316ae930037b6.svg";
export { ForwardRef as ReactComponent };